import { string } from 'yup';
import { FieldType } from '@widgets/EnquiryForm/types/config';
import testPhone from '@widgets/EnquiryForm/validation/testPhone';
export const generatePhoneSchemaObject = ({ type, required }) => {
    if (type !== FieldType.PhoneInput)
        return null;
    let fieldValidation = string().test('test-phone', 'Please enter a valid UK phone number', testPhone);
    if (required) {
        fieldValidation = fieldValidation.required('This is a required field');
    }
    return fieldValidation;
};
